<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fill-rule="evenodd">
            <circle cx="11.92" cy="11.92" r="11.92" fill="#666"/>
            <g fill="#FFF" transform="translate(5.799 8.376)">
                <rect width="8.826" height="6.865" rx="2"/>
                <path d="M10.124 1.056L11.393.55c.512-.206 1.094.044 1.3.557.047.118.07.244.07.371v3.91c0 .553-.447 1-1 1-.126 0-.252-.024-.37-.071l-1.27-.508c-.379-.151-.628-.52-.628-.928V1.985c0-.41.25-.777.629-.929z"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'video-grey-icon'
}
</script>
